import React, { Component } from 'react';

export default class EaeElements extends Component {
    constructor(props) {
        super(props);
        this.state = {
            elements : eaeGlobalVar.eae_elements,
            btnStatus : true
        }
    }

    update_status(event){
        const name = event.target.name;
        const updated_items = this.state.elements;
        updated_items[name]['enabled'] = event.target.checked;
        this.setState({elements : updated_items});
        this.setState({btnStatus : false});
    }
    saveChanges() {
        this.props.set_status('true');
        const items = [];
        Object.keys(this.state.elements).map((key) => (
            //items[key] = this.state.elements[key]['enabled']
            items.push({
                    key : key,
                    enabled : this.state.elements[key]['enabled']
                })
        ));

        jQuery.ajax({
            type: 'POST',
            url: eaeGlobalVar.ajax_url,
            data: {
                action : 'eae_elements_save',
                eae_items : items
            }
        })
            .done(function(data) {
                console.log('Saved');
                this.props.set_status('false');
                this.setState({btnStatus : true})
            }.bind(this))
            .fail(function(jqXhr) {
                console.log('failed to save');
            });
    }

    set_default_check(val){
        if(val === 'true' || val === true || val === null){
            return 'checked';
        }
        else {
            return '';
        }
    }
    render() {
        return[
            <div className={'eae-ele-content-wrapper'}>
                <div className="eae-elements-wrapper">
                    {
                        Object.keys(this.state.elements).map((key) => (

                            <div className="cb-item_animated-marker">
                                <input type="checkbox" id={key} name={key} defaultChecked={this.set_default_check(this.state.elements[key]['enabled'])} className="cb-item_input" onChange={ (event) => this.update_status(event)}/>
                                <label htmlFor={key} className="cb-item_label">
                                    <span className="cb-item_label-content">{this.state.elements[key]['name']}</span>
                                    <span className="cb-item_marker">
                                        <span className="cb-item_marker_short-line"></span>
                                        <span className="cb-item_marker_long-line"></span>
                                    </span>
                                </label>
                        </div>
                            )
                        )
                    }
                </div>
                <div className={'eae-save-button-wrapper'}>
                    <button className={'eae-btn-save-setting'} disabled={this.state.btnStatus} onClick={this.saveChanges.bind(this)}>Save Changes</button>
                </div>
            </div>
            ]
    }
}
